(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('OcorrenciasService', OcorrenciasService);

  OcorrenciasService.$inject = [
    '$http'
  ];
  // eslint-disable-next-line max-lines-per-function
  function OcorrenciasService($http) {
    return {
      changeToNaoOcorrencia,
      edit,
      updateCultivar
    };

    function changeToNaoOcorrencia(registroId, tipoId) {
      return $http.patch(`${SERVER}v1/ocorrencias/registro/${registroId}`, {
        tipo_ocorrencia: tipoId,
        tem_ocorrencia: false
      });
    }

    function edit(id, editData) {
      const data = {
        registro: {
          estadio: editData.estadio.id,
          observacao: editData.observacao,
          ocorrencias_attributes: editData.items.map(getOcorrenciaAttributes)
        }
      };
      return $http.patch(`${SERVER}v1/ocorrencias/registro/${id}`, data);
    }

    function updateCultivar(ocorrencia, cultivar) {
      const dados = {
        ocorrencia: {
          cultivar_id: cultivar.item_id
        }
      };
      const url = `${SERVER}${API_VERSION}ocorrencias/registro/${ocorrencia.sincId}/update_cultivar`;

      return $http({
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        url: url,
        data: dados
      });
    }

    function getOcorrenciaAttributes(item) {
      return {
        tipo: 'praga',
        evento: null,
        tipo_ocorrencia_id: item.type.id,
        data_inicial: null,
        data_final: null,
        acao: null,
        situacao: null,
        tem_ocorrencia: 'S',
        ocorrencia_indicadores_attributes:
          item.type.indicadores.map((indicador) => getOcorrenciaIndicadorAttributes(indicador, item.value))
      };
    }

    function getOcorrenciaIndicadorAttributes(indicador, value) {
      const valueContent = value[indicador.cd_indicador] || {};
      const situacao = valueContent.situacao || {};
      return {
        tipo_dado: indicador.indicador.tipo,
        indicador_id: indicador.cd_indicador,
        numero_faixas: indicador.numero_faixas,
        situacao: situacao.descricaoJson || null,
        valor_1: valueContent.valor1,
        valor_2: valueContent.valor2,
        objeto: JSON.stringify(getOcorrenciaIndicadorObjeto(indicador, valueContent))
      };
    }

    function getOcorrenciaIndicadorObjeto(indicador, valueContent) {
      return {
        id: indicador.cd_indicador,
        titulo: indicador.indicador.titulo,
        dica: null,
        tipo: indicador.indicador.tipo,
        descricao1: indicador.indicador.descricao_valor1,
        descricao2: indicador.indicador.descricao_valor2,
        campos: [],
        equilibrio: indicador.equilibrio,
        controle: indicador.controle,
        emergencia: null,
        valor_1: valueContent.valor1,
        valor_2: valueContent.valor2,
        percentual: valueContent.percentual,
        situacao: valueContent.situacao
      };
    }
  }
}());
